import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/BasketItemPerson`;

const ApiBasketItemPerson = {
  getAll: (params) => {
    const url = `${baseServiceUrl}/GetAll`;
    return ServiceApi.get(url, { params });
  },
  GetItemForWaranty: (params) => {
    const url = `${baseServiceUrl}/GetItemForWarranty`;
    return ServiceApi.post(url, params);
  },
  PayToWaranty: (params) => {
    const url = `${baseServiceUrl}/PayToWaranty`;
    return ServiceApi.post(url, params)
  },
  PayToWaranty2: (params) => {
    const url = `${baseServiceUrl}/PayToWaranty2`;
    return ServiceApi.post(url, params)
  },
  ReceiveFromWarranty: (params) => {
    const url = `${baseServiceUrl}/ReceiveFromWarranty`;
    return ServiceApi.post(url, params)
  },
  GetItemForEditWarranty: (params) => {
    const url = `${baseServiceUrl}/GetItemForEditWarranty`;
    return ServiceApi.post(url, params);
  },
  EditPayToWarranty: (params) => {
    const url = `${baseServiceUrl}/EditPayToWarranty`;
    return ServiceApi.post(url, params)
  },
  EditReceiveFromWarranty: (params) => {
    const url = `${baseServiceUrl}/EditReceiveFromWarranty`;
    return ServiceApi.post(url, params)
  },
  DeletePayOrReceiveWarranty: (params) => {
    const url = `${baseServiceUrl}/DeletePayOrReceiveWarranty`;
    return ServiceApi.post(url, params)
  },
  EditPayOrReceiveWarranty: (params) => {
    const url = `${baseServiceUrl}/EditPayOrReceiveWarranty`;
    return ServiceApi.post(url, params)
  },
  updateStatusAgentCommission: (params) => {
    const url = `${baseServiceUrl}/updateStatusAgentCommission`;
    return ServiceApi.put(url, params)
  },
  getBasketItemPersonsReport: (params) => {
    const url = `${baseServiceUrl}/basketItemPersonsReport`;
    return ServiceApi.get(url, { params });
  },
  getBasketItemPersonsReportByExcel: (params) => {
    const url = `${baseServiceUrl}/getBasketItemPersonsReportByExcel`;
    return ServiceApi.get(url, { params: params, responseType: 'blob' });
  },
  operatorCanceledBasketItemsPersons: (params) => {
    const url = `${baseServiceUrl}/cancelBasketItemPerson`;
    return ServiceApi.put(url, params);
  },
  getEnumType: () => {
    const url = `${baseServiceUrl}/basketCancelStatusType`;
    return ServiceApi.get(url);
  },
  updateAgentCommissionPrice: (params) => {
    const url = `${baseServiceUrl}/updateAgentCommissionPrice`;
    return ServiceApi.put(url, params);
  },
  amusementSellReportCharts: (params) => {
    const url = `${baseServiceUrl}/amusementSellReportCharts`;
    return ServiceApi.get(url, { params });
  }
};

export default ApiBasketItemPerson;





